module.exports = __webpack_public_path__ + "static/media/choithramsLays.23e6a242.png";